import {FormHelperText, FormLabel, Slider} from "@mui/material";
import {NumberField} from "helpers/forms/fields/NumberField";
import {fieldPropTypes} from './FieldPropTypes';

/**
 * SliderField component for rendering a slider input field.
 *
 * @param {Object} props - The props object containing input, label, meta, min, max, step, text_input, defaultSliderValue, and disabled properties.
 * @return {ReactElement} The SliderField component.
 */
export const SliderField = ({input, label, meta, min, max, step, text_input, defaultSliderValue, disabled}) => {
  if (text_input) {
    return (
      <NumberField
        defaultValue={defaultSliderValue}
        input={input}
        label={label}
        meta={meta}
        min={min}
        max={max}
        step={1}
        disabled={disabled}
      />
    );
  } else {
    const {invalid, error} = meta;

    return (
      <div>
        <FormLabel component={"legend"}>{label}</FormLabel>
        <Slider
          sx={
            {
              '.MuiSlider-mark': {
                width: "6px",
                height: "6px",
                borderRadius: "100%"
              }
            }
          }
          defaultValue={defaultSliderValue}
          onChange={
            (_event, value) => {
              input.onChange(value);
            }
          }
          marks
          track={false}
          valueLabelDisplay={"auto"}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
        />
        {
          invalid && (
            <FormHelperText error>
              {error}
            </FormHelperText>
          )
        }
      </div>
    );
  }
};

SliderField.propTypes = {
  ...fieldPropTypes
};
